export enum UserRole {
  ADMIN = "ADMIN",
  SUPERADMIN = "SUPER-ADMIN",

  NationalMuseumEvent = "NATIONAL-MUSEUM-EVENT",

  COUNTER = "COUNTER",
  VISITORSERVICE = "VISITOR-SERVICE",
  LEARNINGCENTER = "LEARNING-CENTER",
  MUSEUMFRIENDSDEPARTMENT = "MUSEUM-FRIENDS-DEPARTMENT",
  STATISTICSDEPARTMENT = "STATISTICS-DEPARTMENT",
  FINANCEDEPARTMENT = "FINANCE-DEPARTMENT",

  CUSTOMER = "VISITORS",

  SECURITY = "SECURITY",
  CREATOR = "CREATOR",
  APPROVER = "APPROVER",
  GUEST = "GUEST",
  KIOSK = "KIOSK",
}
